var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorldwideweb21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33978 4.03907H6.14845V1.26175C5.39344 1.50967 4.71443 2.56947 4.33978 4.03907Z",
    fill: "#169C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33978 8.96094C4.71443 10.4305 5.39344 11.4903 6.14845 11.7383V8.96094H4.33978Z",
    fill: "#169C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1484 4.74219H0.851562C0.657406 4.74219 0.5 4.89955 0.5 5.09375V7.90625C0.5 8.10041 0.657406 8.25781 0.851562 8.25781H12.1484C12.3426 8.25781 12.5 8.10041 12.5 7.90625V5.09375C12.5 4.89955 12.3426 4.74219 12.1484 4.74219ZM11.7364 5.95412L11.0332 7.36037C10.9735 7.4795 10.852 7.55469 10.7188 7.55469C10.5855 7.55469 10.464 7.4795 10.4043 7.36037L10.0156 6.58309L9.62698 7.36037C9.5075 7.59863 9.1175 7.59863 8.99802 7.36037L8.32442 6.01283C8.2839 5.96309 8.26081 5.90061 8.25331 5.83391C8.24898 5.87455 8.24009 5.9154 8.22073 5.95412L7.51761 7.36037C7.45787 7.4795 7.33634 7.55469 7.20312 7.55469C7.06991 7.55469 6.94838 7.4795 6.88864 7.36037L6.5 6.58309L6.11136 7.36037C5.99187 7.59863 5.60188 7.59863 5.48239 7.36037L4.77927 5.95412C4.76063 5.91687 4.75262 5.87755 4.74793 5.83845C4.73909 5.9142 4.7105 5.98325 4.66423 6.03582L4.00196 7.36037C3.94224 7.4795 3.82072 7.55469 3.6875 7.55469C3.55428 7.55469 3.43276 7.4795 3.37302 7.36037L2.98438 6.58309L2.59573 7.36037C2.53599 7.4795 2.41447 7.55469 2.28125 7.55469C2.14803 7.55469 2.02651 7.4795 1.96677 7.36037L1.26364 5.95412C1.17678 5.7804 1.24716 5.56925 1.42088 5.48239C1.59425 5.39656 1.80507 5.46556 1.89261 5.63963L2.28125 6.41691L2.66989 5.63963C2.79427 5.39005 3.16883 5.37955 3.29886 5.63963L3.6875 6.41691L4.07614 5.63963C4.1393 5.51328 4.27217 5.44463 4.41329 5.44599C4.595 5.45792 4.73945 5.60778 4.74709 5.78605C4.75128 5.66134 4.81705 5.54211 4.93651 5.48237C5.11058 5.39654 5.32102 5.46554 5.40823 5.63961L5.79688 6.41691L6.18552 5.63963C6.305 5.40137 6.695 5.40137 6.81448 5.63963L7.20312 6.41691L7.59177 5.63963C7.67863 5.46556 7.88977 5.39656 8.06349 5.48239C8.18195 5.54162 8.24722 5.65932 8.25249 5.78284C8.25931 5.60623 8.38489 5.45921 8.56541 5.44737C8.7103 5.44395 8.86067 5.5133 8.92386 5.63963L9.3125 6.41691L9.70114 5.63963C9.82063 5.40137 10.2106 5.40137 10.3301 5.63963L10.7188 6.41691L11.1074 5.63963C11.1946 5.46556 11.405 5.39656 11.5791 5.48239C11.7528 5.56925 11.8232 5.7804 11.7364 5.95412Z",
    fill: "#169C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85156 8.96094V11.7383C7.60658 11.4903 8.28559 10.4305 8.66023 8.96094H6.85156Z",
    fill: "#169C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85156 1.26175V4.03907H8.66023C8.28559 2.56947 7.60658 1.50967 6.85156 1.26175Z",
    fill: "#169C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61764 8.96094H1.07526C2.03622 11.0708 4.16408 12.5 6.50001 12.5C5.23002 12.5 4.12056 11.1014 3.61764 8.96094Z",
    fill: "#169C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38237 8.96094C8.87945 11.1014 7.76998 12.5 6.5 12.5C8.83592 12.5 10.9638 11.0708 11.9247 8.96094H9.38237Z",
    fill: "#169C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07526 4.03906H3.61764C4.12056 1.89861 5.23002 0.5 6.50001 0.5C4.16408 0.5 2.03622 1.92917 1.07526 4.03906Z",
    fill: "#169C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.5C7.76998 0.5 8.87945 1.89861 9.38237 4.03906H11.9247C10.9638 1.92917 8.83592 0.5 6.5 0.5Z",
    fill: "#169C50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldwideweb21);
export default __webpack_public_path__ + "static/media/worldwideweb-2-1.68106ff2fa55a977ade74859f5ab962f.svg";
export { ForwardRef as ReactComponent };